import React from 'react';
import { BaseIcon } from './baseIcon';

export const Youtube = () => (
  <BaseIcon xmlns="http://www.w3.org/2000/BaseIcon" viewBox="0 0 24 24" height="24" fill="none" width="24">
    <path
      d="M9.95432 14.9547V9.04531L15.1819 12L9.95432 14.9547ZM22.5404 6.49833C22.2876 5.51505 21.5418 4.74087 20.595 4.47772C18.8798 4 11.9997 4 11.9997 4C11.9997 4 5.12021 4 3.40442 4.47772C2.45768 4.74087 1.71244 5.51505 1.45962 6.49833C1 8.2809 1 12 1 12C1 12 1 15.7191 1.45962 17.5017C1.71244 18.485 2.45768 19.2597 3.40442 19.5223C5.12021 20 11.9997 20 11.9997 20C11.9997 20 18.8798 20 20.595 19.5223C21.5418 19.2597 22.2876 18.485 22.5404 17.5017C23 15.7191 23 12 23 12C23 12 23 8.2809 22.5404 6.49833Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="white"
    />
  </BaseIcon>
);
